import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { IAtHomeListingFiltersParamsBody, IAtHomeListingResponse } from "@/api_framework/api_modals/Patients";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setPatientWaitingList } from "@/app_redux/reducers/slices/auth/patient_waiting_list_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export const useAtHomeServicesListingAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();

  const execute = useCallback(
    async (filterParams: IAtHomeListingFiltersParamsBody) => {
      dispatch(
        setLoading({
          key: "isAtHomeServicesListingInProgress",
          status: true,
        }),
      );

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const requestBody = {
          booking_date: filterParams.date,
          booking_status: filterParams.booking_status,
          clinic_id: filterParams.clinic_id,
          sub_service_id: filterParams.sub_service_id,
          staff_id: filterParams.staff_id,
          created_by: filterParams.created_by,
        };
        const response: AxiosResponse<IAtHomeListingResponse> = await axios.post(
          PATIENT_WAITING_LIST?.AT_HOME_LISTING?.baseURL ?? "",
          requestBody,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );

        dispatch(
          setPatientWaitingList({
            data: response?.data?.status ? (response?.data?.data ?? []) : [],
          }),
        );
      } catch (error) {
        // const axiosError = error as AxiosError;
        // captureError(axiosError);
        // sendCurl((axiosError.config as any)?.curlCommand);
        dispatch(
          setPatientWaitingList({
            data: [],
          }),
        );
      } finally {
        dispatch(
          setLoading({
            key: "isAtHomeServicesListingInProgress",
            status: false,
          }),
        );
      }
    },
    [captureError, configuration.localStorage.ACCESS_TOKEN.key, dispatch, sendCurl],
  );

  return execute;
};
